import React from "react";
import PropTypes from "prop-types";
import Header from "../Shared/header";
import NavBar from "../NavigationBar/NavBar";

const OurLayouts = ({ children }) => {
  return (
    <div className="flex w-full min-h-screen">
      <div className="w-[15%] h-full">
        <NavBar />
      </div>
      <div className="w-[85%] bg-primary overflow-hidden">
        <div className="rounded-t-3xl rounded-b-3xl bg-white min-h-screen">
          <Header className="w-full" />
          <main className="ml-5 w-full h-[calc(100vh-4rem)] overflow-y-auto overflow-x-hidden">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

OurLayouts.propTypes = {
  children: PropTypes.node.isRequired,
};

export default OurLayouts;